import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
  sessionUrl: '',
  campaigns: [],
};

export const getCampaignsSummary = createAsyncThunk('campaign/get-campaigns-summary', async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/campaign/summary`);
    return response?.data;
  } catch (error) {
    notification.error({
      message: 'Error',
      description: error?.response?.data?.message || error?.response?.data?.errors?.[0]?.message || 'Network error',
    });

    return rejectWithValue(error?.response);
  }
});

const getCampaignsSummarySlice = createSlice({
  name: 'Get Campaigns Summary',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCampaignsSummary.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
    });
    builder.addCase(getCampaignsSummary.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action?.payload?.success;
      state.message = action?.payload?.message;
      state.campaigns = action?.payload?.campaigns;
    });
    builder.addCase(getCampaignsSummary.rejected, (state, action) => {
      state.isLoading = false;
      state.errors = action.payload?.errors || [];
      state.isError = true;
    });
  },
});

export default getCampaignsSummarySlice?.reducer;
